// date.js
export function formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    return fmt;
}

export function formatNoTime_ZH (str) {
  var date = new Date(str);
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()

  return year+'年'+month+'月'+day+'日';
}

function padLeftZero(str) {
    return ('00' + str).substr(str.length);
}

export function str2Date(dateStr, separator) {
    if (!separator) {
        separator = "-";
    }
    let dateArr = dateStr.split(separator);
    let year = parseInt(dateArr[0]);
    let month;
    //处理月份为04这样的情况
    if (dateArr[1].indexOf("0") == 0) {
        month = parseInt(dateArr[1].substring(1));
    } else {
        month = parseInt(dateArr[1]);
    }
    let day = parseInt(dateArr[2]);
    let date = new Date(year, month - 1, day);
    return date;
}

export function dataURLtoBlob(dataurl) {
  var arr = dataurl.split(",")
  var mime = arr[0].match(/:(.*?);/)[1]
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

export const checktel = (mobile) => {
		 if (/^((1[2,3,4,5,6,,7,8,9][0-9]))\d{8}$/.test(mobile)) {
            return true;
          }
          return false;
			}
export const mobileValidate = (mobile) => {
  if (/^((1[2,3,4,5,6,,7,8,9][0-9]))\d{8}$/.test(mobile)) {
    return true;
  }
  return false;
}
export function get_now_date(t){
  var timestamp = Date.parse(t);
  var date = new Date(timestamp);
  //获取年份
  var Y =date.getFullYear();
  //获取月份
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  //获取当日日期
  var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();

  return Y+'-'+M+'-'+D;
}

export function get_date_time(t){
  var timestamp = Date.parse(t);
  var date = new Date(timestamp);
  //获取年份
  var Y =date.getFullYear();
  //获取月份
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  //获取当日日期
  var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  //获取当日日期
  var hh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
  var mm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
  var ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();

  return Y+'-'+M+'-'+D+' '+hh+':'+mm+':'+ss;
}

export function getYearMonth(date){
    // 将日期以空格隔开，即['2020-06-13', '17:10:09']
    date = (date + '').split(/[ ]+/);
    let result = [];
    let reg = /^(\d{4})-(\d{1,2})-(\d{1,2})$/;
    // 用截取出来的年月日进行正则表达式匹配
    reg.exec(date[0]);
    result.push(RegExp.$1);	//获取匹配到的第一个子匹配，即‘2020’
    result.push(RegExp.$2);
    result.push(RegExp.$3);
    return result[0]+'-'+result[1]+'-'+result[2];
}



export const dataURLtoFile = (dataurl, filename) => {
  let arr = dataurl.split(','),
  mime = arr[0].match(/:(.*?);/)[1],
  bstr = atob(arr[1]),
  n = bstr.length,
  u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: mime
  });
}


// WEBPACK FOOTER //
// ./src/utils/date.js